import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../animations/page-transitions';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { SlideButtonComponent } from '../../slide-button/slide-button.component';

import { WidgetContentChecker } from './available-widgets';

interface SelectedType {
	type: 'steelgrade' | 'customerArticleReference';
}

@Component({
	selector: 'copo-biggest-stocks-selector',
	templateUrl: './biggest-stocks-selector.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule, SlideButtonComponent]
})
export class BiggestStocksSelectorComponent implements OnInit, WidgetContentChecker {
	@Input() currentContent?: unknown;
	@Output() readonly content = new EventEmitter<unknown>(true);
	user: User;
	steelgradeSelected = true;
	selectedType: SelectedType = { type: 'steelgrade' };

	constructor(private readonly userService: UserService) {
		this.user = this.userService.user;
		this.selectedType.type = 'steelgrade';
	}

	onToggleChange(eventChange: boolean) {
		this.steelgradeSelected = eventChange;
		this.selectedType.type = this.steelgradeSelected ? 'steelgrade' : 'customerArticleReference';
	}

	ngOnInit() {
		this.updateCurrentStatus();
		this.content.emit(this.selectedType);
	}

	private updateCurrentStatus() {
		if (!this.currentContent) {
			return;
		}

		const content = <ContentType> this.currentContent;

		switch (content.type) {
		case 'steelgrade':
			this.steelgradeSelected = true;
			break;
		case 'customerArticleReference':
			this.steelgradeSelected = false;
			break;
		}
	}
}

interface ContentType {
	type: 'steelgrade' | 'customerArticleReference';
}
